import { Component, inject, input, InputSignal } from '@angular/core';
import { BlockUiService } from '../../../core/services/ui/block-ui.service';

@Component({
  selector: 'app-loading',
  imports: [],
  template: `
    @if (blockUIService.loading() || loading()) {
    <div class="fixed inset-0 z-[9999] flex items-center justify-center" [class]="blockUIService.isBootstrap() ? 'bg-white' : 'bg-black/50'">
      <div
        class="h-16 w-16 animate-spin rounded-full border-4 border-t-4 border-gray-200 border-t-blue-500"
      ></div>
    </div>
    }
  `,
  standalone: true,
  styles: ``,
})
export class LoadingComponent {
  protected blockUIService: BlockUiService = inject(BlockUiService);
  public loading: InputSignal<boolean> = input<boolean>(false);
}
